export const ShiftsPageView = require('./ShiftsPageView').default;
export const ShiftsCreatePageView = require('./ShiftsCreatePageView').default;
export const ShiftsUpdatePageView = require('./ShiftsUpdatePageView').default;
